import { type MicroCopy } from '@vakantiesnl/types/src';

export function getUnitDescription(unitTag: string, microCopies: MicroCopy): string {
	let unitDescription = '';

	switch (unitTag) {
		case 'Persoon per nacht':
			unitDescription = microCopies['price.quantities.personPerNight'];
			break;
		case 'Huisdier per nacht':
			unitDescription = microCopies['price.quantities.petPerNight'];
			break;
		case 'Persoon':
			unitDescription = microCopies['price.quantities.person'];
			break;
		case 'Nacht':
			unitDescription = microCopies['price.quantities.night'];
			break;
		case 'Stuk':
			unitDescription = microCopies['price.quantities.piece'];
			break;
		default:
			return '';
	}

	return unitDescription ? `(${unitDescription})` : '';
}
